import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    // iOS : muted DOIT être forcé en JS avant play()
    videoElement.muted = true;
    videoElement.playsInline = true;

    videoElement.load();

    const tryPlay = () => {
      videoElement.muted = true;
      const p = videoElement.play();
      if (p && p.catch) {
        p.catch(() => {
          // iOS bloque encore : relance au premier contact
          const once = () => {
            videoElement.muted = true;
            videoElement.play();
            document.removeEventListener('touchstart', once);
            document.removeEventListener('click', once);
          };
          document.addEventListener('touchstart', once, { once: true, passive: true });
          document.addEventListener('click', once, { once: true });
        });
      }
    };

    videoElement.addEventListener('loadeddata', tryPlay, { once: true });
    tryPlay();
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}